import React from 'react';
import PropTypes from 'prop-types';
import { Text, View, TouchableOpacity } from 'react-native';

import { Icon } from '../../components';
import Theme from '../../theme';
import { styles } from './Styles';

const SelectWorkoutCard = ({
  t, icon, onPress, title, subtitle, description, isMore, isActive
}) => (
    <TouchableOpacity
      onPress={onPress}
      style={[styles.cardContainer, isActive && styles.activeCardContainer]}>
      <View style={styles.cardInfoSection}>
        <View style={styles.cardHeader}>
          {icon &&
            <View style={styles.iconContainer}>
              {icon}
            </View>
          }
          <View style={[styles.headerContainer, !subtitle && { alignSelf: 'center' }]}>
            <View style={styles.titleContainer}>
              <Text style={[styles.title, isActive && styles.activeTitle]}>{title}</Text>
            </View>
            {subtitle &&
              <View style={styles.subtitleInnerContainer}>
                <Text style={styles.subtitle}>{subtitle}</Text>
              </View>
            }
          </View>
        </View>
        <View>
          <Text>
            <Text style={styles.description}>{description}</Text>
            {isMore &&
              <Text style={styles.moreText}> {t('more')}</Text>
            }
          </Text>
        </View>
      </View>
      <View style={styles.arrowContainer}>
        <Icon
          size={25}
          color={Theme.WHITE}
          name="ios-arrow-forward"
        />
      </View>
    </TouchableOpacity>
  );

SelectWorkoutCard.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  description: PropTypes.string.isRequired,
  icon: PropTypes.element,
  onPress: PropTypes.func.isRequired,
  isMore:  PropTypes.bool,
};

export default SelectWorkoutCard;
